import { API } from "@/utils/http"

export default {
  async get({ pageSize = 10, page = 1, query = {} } = {}) {
    const paginationQuery = {
      limit: pageSize,
      offset: (page - 1) * pageSize
    }
    const params = {
      ...query,
      ...paginationQuery,
      ordering: "-created_at"
    }
    const response = await API.get(`/v2/seller/deliveries/`, { params })

    return response
  },

  // todo: do it as one recursive method
  async getAll({ pageSize = 50, page = 1 } = {}) {
    const params = {
      limit: pageSize,
      offset: (page - 1) * pageSize
    }
    const response = await API.get(`/v2/seller/deliveries/`, { params })

    return response
  },

  async getAllActive({ pageSize = 50, page = 1 } = {}) {
    const params = {
      limit: pageSize,
      offset: (page - 1) * pageSize
    }
    const query = {
      is_active: true
    }
    const response = await API.get(`/v2/seller/deliveries/`, {
      params: Object.assign({}, params, query)
    })

    return response
  },

  getOne(uuid) {
    return API.get(`/v2/seller/deliveries/${uuid}`)
  },

  async getMeta() {
    const response = await API.get(`/v2/seller/deliveries/meta`)

    return response
  },

  async create(data) {
    const response = await API.post(`/v2/seller/deliveries/`, data)

    return response
  },

  async update(uuid, data) {
    const response = await API.put(`/v2/seller/deliveries/${uuid}`, data)

    return response
  },

  async deleteDelivery(uuid) {
    const response = await API.delete(`/v2/seller/deliveries/${uuid}`)

    return response
  },

  async createConfig(uuid, data) {
    const response = await API.post(`/v2/seller/deliveries/${uuid}/configs`, data)

    return response
  },

  async updateConfig({ deliveryUuid, configUuid, data }) {
    const response = await API.put(
      `/v2/seller/deliveries/${deliveryUuid}/configs/${configUuid}`,
      data
    )

    return response
  },

  async deleteConfig({ deliveryUuid, configUuid }) {
    const response = await API.delete(`/v2/seller/deliveries/${deliveryUuid}/configs/${configUuid}`)

    return response
  }
}
